<div class="hero-content" [class.hero-content--reversed]="reverseContentMobile">
    <div class="hero-content__first">
        <ng-content select=".hero-content-first"></ng-content>
    </div>
    <div class="hero-content__second">
        <ng-content select=".hero-content-second"></ng-content>
    </div>
</div>
